import { DealBuilderFormValues, DealBuilderStep, DealBuilderSummaryItemConfig, StepConfig } from '../types';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { SaleType } from 'modules/desking';

// Matches the palette used for contact avatars elsewhere in the app (see modules/dealActivity)
export const CONTACT_AVATAR_COLORS = ['#E1BEE7', '#BBDEFB', '#B2DFDB', '#FFE0B2', '#F8BBD0', '#C8E6C9'];

export const STEP_CONFIG: StepConfig[] = [
  { step: DealBuilderStep.Contacts, label: 'Contacts' },
  { step: DealBuilderStep.Equipment, label: 'Equipment' },
  { step: DealBuilderStep.Pricing, label: 'Pricing' },
  { step: DealBuilderStep.FinanceMenu, label: 'Finance & Menu', subLabel: '(Recommended)' },
  { step: DealBuilderStep.ReviewSend, label: 'Review & Send' },
];

// Matches the design: show at most 2 unselected recipients besides the primary contact
export const MAX_ADDITIONAL_RECIPIENTS = 2;

export const DEAL_BUILDER_SUMMARY_ITEMS: DealBuilderSummaryItemConfig[] = [
  { key: 'hardCost', label: 'Hard Cost', color: 'default' },
  { key: 'feesAndTaxes', label: 'Fees & Taxes', color: 'default' },
  { key: 'customerDeposit', label: 'Customer Deposit', color: 'secondary' },
  /* { key: 'tradeIn', label: 'Trade-In', color: 'warning' }, */
  { key: 'balanceDue', label: 'Balance Due', color: 'info' },
];

export const DEAL_BUILDER_DEFAULT_VALUES: DealBuilderFormValues = {
  contacts: {
    ownerPgIds: [],
    accountContactIds: [],
  },
  equipment: {
    selectedId: null,
  },
  pricing: {
    lineItems: [],
    customerDeposit: { type: QuoteDepositType.Flat, value: 0, notes: '' },
  },
  financeMenu: { isEnabled: false, saleType: SaleType.Financing },
  reviewSend: {},
};

export const CUSTOMER_DEPOSIT_TYPE_OPTIONS = [
  { label: 'Percentage', value: QuoteDepositType.Percentage },
  { label: 'Flat Amount', value: QuoteDepositType.Flat },
];

// Kept separate from the tab's own `#hash` (see TabsContainer) so both can coexist in the URL
export const DEAL_BUILDER_QUERY_PARAM_STEP = 'dbStep';
export const DEAL_BUILDER_QUERY_PARAM_PROGRESS = 'dbProgress';

export const DESKING_SYNC_DEBOUNCE_MS = 1000;

export const SALE_TYPE_OPTIONS = [
  { value: SaleType.Financing, label: 'Financing', description: 'Add loan terms, rates, and payment options' },
  { value: SaleType.Cash, label: 'Cash', description: 'Add aftermarket products only. No financing' },
] as const;
